<template>
  <section class="row-12">
    <h2 class="col-6 col-sm-12">Konspekty udostępnione dla Ciebie</h2>
    <div class="col-6 col-sm-12">
      <div class="row-12 m-t-2">
        <div class="col-12 col-sm-12 input-with-icon">
          <input id="searchFilter" v-model="inputText" placeholder="Wyszukaj..."/>
          <i class="i-search"></i>
        </div>
      </div>
    </div>
    <div class="col-12 m-t-1 m-b-5">
      <div class="row-12" v-if="filteredList.length > 0">
        <div class="card col-4 col-sm-12 col-md-6 wow fadeIn" v-for="conspect in conspectList" :key="conspect.id">
          <div class="card-body" style="padding-right:50px;">
              <div class="row-12">
                  <div class="col-12 center-flex-a" style="justify-content: flex-start">
                      <i class="i-calendar text-primary i-md"></i>
                      <small> {{conspect.date}}</small>
                  </div>
              </div>
            <h4 class="m-t-4 m-b-2">{{conspect.title}}</h4>
            <p class="m-y-1" style="min-height: 48px;" v-if="conspect.description.length > 0"> {{conspect.description}} </p>
            <p class="m-y-1" style="min-height: 48px;" v-else> Ten projekt nie posiada opisu. Przejdź do edycji, aby go uzupełnić.</p>
              <div class="side-menu" style="height: 100%;">
                  <c-sidemenu
                          :icon="'i-sm i-download'"
                          @click.native="downloadConspectModal(conspect.id, conspect.title)"
                          :links="[{name: 'Pobierz'}]"
                  />
              </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12" v-else>
        <error-notifier
                type="info"
                title="Brak konspektów do wyświetlenia"
                message="Nie posiadasz żadnych udostępnionych konspektów"
        />
      </div>
    </div>
      <div class="modal" id="modalDowloadConspect" >
          <div class="modal-header">
              Pobierz konspekt w odpowiadającym Ci formacie.
          </div>
          <div class="modal-body">
              <div class="card">
                  <div class="card-image" style="max-width: 450px;">
                      <img src="../../assets/sample_cmc.png" alt="CMC_THEME">
                  </div>
                  <div class="card-body" style="position: relative;">
                      <button class="select-button-in-card" @click="downloadConspect('cmc-theme')" >Wybierz</button>
                      <h3>Format Club Management Center</h3>
                      <p>Nowoczesność, czytelność i prostota.</p>
                  </div>
              </div>
              <div class="card">
                  <div class="card-body" style="position: relative;">
                      <button class="select-button-in-card" @click="downloadConspect('pzpn-theme')" >Wybierz</button>
                      <h3>Format PZPN</h3>
                      <p>Format w pełni zgodny z formatem konspektu PZPN</p>
                  </div>
              </div>
          </div>
          <div class="modal-action flex-align-right">
              <button class="button-free-p" @click="denyDelete()">Anuluj</button>
          </div>
      </div>

    <div class="modal" id="modalPromptForDelete" >
      <div class="modal-header">
        Nieodwracalne usunięcie konspektu
      </div>
      <div class="modal-body">
        <p >Jesteś pewny, że chcesz usunąć dany konspekt?</p>
      </div>
      <div class="modal-action flex-align-right">
        <button class="button-free-p" @click="denyDelete()">Anuluj</button>
        <button @click="allowDelete()">Tak, usuń</button>
      </div>
    </div>
  </section>
</template>

<script>
    import SideMenu from '../../components/CardSideMenu'
    import Search from '../../components/Search'
    import ErrorNotifier from '../../components/ErrorFullNotifier'

    export default {
        components: {
            'c-sidemenu': SideMenu,
            'c-search': Search,
            'error-notifier': ErrorNotifier
        },
        data: () => {
            return {
                conspectList: [],
                elementToDeleteId: null,
                showAlphabetically: false,
                showChronological: false,
                filteredList: [],
                inputText: '',
                pickedDate: '',
                downloadConspId: -1,
                downloadConspName: '',
                friends: true,
                actualSharedElementId: null,
                sharedData: {
                    friendsNoShared: [],
                    friendsShared: []
                },
            };
        },
        methods: {
            downloadConspect(themeName){
                axios.post(`conspect/${this.downloadConspId}/download/${themeName}`, {responseType: 'blob'})
                    .then((response) => {
                        if (response.data) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.downloadConspName + ".pdf");
                            document.body.appendChild(link);
                            link.click();
                            notify.createNotifier("Pobieranie pliku .pdf rozpoczęte.", "info", 2000);
                        }
                    })
                    .catch(() => {
                        notify.createNotifier("Niestety coś jest nie tak z Twoim konspektem. Prosimy spróbuj za minutę.", "danger", 4000);
                    })
            },
            showModal(name){$(name).showModal()},
            hideModal(name){$(name).hideModal()},
            changeFilter(type) {
                this.conspectList = this.filteredList;
                this.conspectList = type === 'alf' ? this.conspectList.sort((a, b) => a.name.localeCompare(b.name)) : this.conspectList.sort((a, b) => b.date_add.localeCompare(a.date_add));
                this.filterPractice();
                this.filterAnimation();
            },
            filterPractice() {
                this.filterAnimation(() => {
                    let input = this.inputText.toLowerCase();
                    let self = this;
                    this.filteredList = [];
                    if (input.length !== 0) {
                        this.conspectList.filter(function (item) {
                            if (item.title.toLowerCase().includes(input))
                                self.filteredList.push(item)
                        })
                    } else {
                        this.filteredList = this.conspectList;
                    }
                })
            },
            filterAnimation(callback) {
                'use strict';

                $(document).off('keyup', '#searchFilter');
                $(document).on('keyup', '#searchFilter', function (e) {
                    e.preventDefault();

                    $('.card').each(function () {
                        $(this).addClass('is-animated').stop().fadeOut(500);
                    });

                    setTimeout(() => {
                        if(callback) callback();
                        $('.card').each(function () {
                            $(this).removeClass('is-animated').addClass('is-animated-a').stop().fadeIn(500);
                        });
                    }, 550);
                });
            },
            filterDate() {
                let self = this;

                let dateFrom = $("#calendarPickerFrom").val();
                let dateTo = $("#calendarPickerTo").val();

                dateTo = (dateTo == "" ? null : moment(dateTo));
                dateFrom = (dateFrom == "" ? null : moment(dateFrom));

                this.filteredList = [];
                this.conspectList.filter(function (item) {
                    let animationsDate = moment(item.date);

                    if(dateTo && dateFrom && animationsDate.isBetween(dateFrom, dateTo,null, '[]')){
                        self.filteredList.push(item);
                    }else if(dateTo && !dateFrom && animationsDate.isSameOrBefore(dateTo)){
                        self.filteredList.push(item);
                    }else if(dateFrom && !dateTo && animationsDate.isSameOrAfter(dateFrom)){
                        self.filteredList.push(item);
                    }else if(!dateFrom && !dateTo){
                        self.filteredList.push(item);
                    }

                })
            },
            showFilters() {
                if ($('.projectsNavigation div.filterOptions').hasClass('showFilter')) {
                    $('.projectsNavigation .filterOptions').removeClass('showFilter');
                } else {
                    $('.projectsNavigation .filterOptions').addClass('showFilter');
                }
            },
            downloadConspectModal(id, name){
                this.downloadConspId = id;
                this.downloadConspName = name.replace(" ", "_");
                this.showModal("#modalDowloadConspect");
            }
        },
        mounted: function () {
            let self = this;
            axios.get(`conspect/shared`)
                .then((response) => {
                    this.conspectList = response.data;

                    $(document).off('keyup', '#searchFilter');
                    $(document).on('keyup', '#searchFilter', this.filterPractice);

                    this.filteredList = this.conspectList;

                    $('.calendarPicker').datepicker({
                        format: "yyyy-mm-dd",
                        language: 'pl-PL',
                    });

                    $(document).off('change', '.calendarPicker');
                    $(document).on('change', '.calendarPicker', function () {
                        self.filterDate();
                    });
                })
        },
    }
</script>

<style>
    .select-button-in-card{
        position: absolute;
        top: -25px;
        left: calc(50% - 12px);
        transform: translateX(-50%);
    }
</style>

